__turbopack_context__.v({
  "className": "poppins_e4be706a-module__ut2hqG__className",
  "variable": "poppins_e4be706a-module__ut2hqG__variable",
});
